var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "config-params-tree" },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "config-params-tree__loading" },
            [
              _c("b-spinner", {
                staticClass: "mr-1",
                attrs: { variant: "primary" }
              })
            ],
            1
          )
        : [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              staticClass: "form-control config-params-tree__search",
              attrs: { placeholder: "Buscar..." },
              domProps: { value: _vm.search },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            }),
            _c(
              "div",
              {
                ref: "nodesContainer",
                staticClass: "config-params-tree__nodes"
              },
              [
                _vm._l(_vm.filteredTree, function(node) {
                  return [
                    _c("config-params-tree-node", {
                      key: node.optionId || node.id,
                      attrs: {
                        node: node,
                        level: 0,
                        "selected-id": _vm.selectedId,
                        "is-super-admin": _vm.isSuperAdmin,
                        "expanded-nodes": _vm.expandedNodes,
                        "force-expand-all": _vm.isSearchActive
                      },
                      on: {
                        "select-item": _vm.onSelectItem,
                        "toggle-expand": _vm.onToggleExpand,
                        "context-action": _vm.onContextAction
                      }
                    })
                  ]
                })
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }